module.exports = __webpack_public_path__ + "static/media/TaxQuestions2.a176e085.png";